import _Button from "@mui/material/Button";
import _Typography from "@mui/material/Typography";
import _Tooltip from "@mui/material/Tooltip";
import _Box from "@mui/material/Box";
import _IconButton from "@mui/material/IconButton";
import _Close from "@mui/icons-material/Close";
import { red } from '@mui/material/colors';
import React, { useEffect, useRef, useState } from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
const acceptedTypes = {
  '*': '*',
  image: 'image/*',
  csv: '.csv',
  gpx: '.gpx',
  geojson: '.geojson',
  shp: '.zip',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  sheet: '.xlsx,.xls,.csv'
};
export function FileInput({
  disableCard,
  disabled,
  error,
  buttonLabel,
  type,
  file,
  disablePreview,
  emptyStateLabel,
  removeButtonLabel,
  removeIcon,
  savedFileName,
  size,
  onChange
}) {
  const [previewUrl, setPreviewUrl] = useState();
  const inputRef = useRef(null);
  useEffect(() => {
    if (file && type === 'image') {
      if ('url' in file) setPreviewUrl(file.url);
    } else {
      setPreviewUrl(undefined);
    }
  }, [file]);
  function handleChange({
    target: {
      files
    }
  }) {
    const newFile = files?.[0];
    if (newFile && type === 'image') {
      setPreviewUrl(URL.createObjectURL(newFile));
    }
    onChange(newFile || file);
  }
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: [disableCard ? '' : 'card', error ? 'error' : ''].filter(Boolean).join(' ')
  }, /*#__PURE__*/React.createElement(StyledHiddenInput, {
    accept: acceptedTypes[type],
    onChange: handleChange,
    onClick: ({
      currentTarget
    }) => currentTarget.value = '',
    ref: inputRef,
    type: "file"
  }), /*#__PURE__*/React.createElement(StyledName, {
    noWrap: true,
    color: !file && !savedFileName ? '#6B7280' : 'black',
    overflow: "hidden",
    textOverflow: "ellipsis",
    variant: "subtitle1"
  }, file ? file.name : savedFileName ? savedFileName : emptyStateLabel || /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.no_file_choosen"
  })), !disablePreview && /*#__PURE__*/React.createElement(React.Fragment, null, previewUrl && /*#__PURE__*/React.createElement(StyledThumbnail, {
    size: size,
    url: previewUrl
  }), file && /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "left",
    title: removeButtonLabel || /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.actions.remove"
    })
  }, /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    marginLeft: "8px"
  }, /*#__PURE__*/React.createElement(_IconButton, {
    disabled: disabled,
    onClick: () => onChange(null),
    size: "small"
  }, removeIcon || /*#__PURE__*/React.createElement(_Close, {
    fontSize: "small"
  }))))), /*#__PURE__*/React.createElement(StyledButton, {
    color: !error ? 'primary' : undefined,
    disabled: disabled,
    onClick: () => inputRef.current?.click(),
    size: size,
    style: error ? {
      borderColor: red[500],
      color: red[500]
    } : {},
    variant: "text"
  }, buttonLabel || /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.choose",
    values: {
      context: type === '*' ? 'file' : type
    }
  })));
}
const Wrapper = styled.div`
  align-items: center;
  display: flex;

  &.card {
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 4px;

    &.error {
      border-color: ${red[500]};
    }
  }

  &:not(.card) {
    flex-grow: 1;
  }

  > button {
    flex-shrink: 0;
  }
`;
const StyledHiddenInput = styled.input`
  display: none;
`;
const StyledName = styled(_Typography)`
  && {
    flex-grow: 1;
    min-width: 0;
    margin: 0 16px;
  }
`;
const StyledThumbnail = styled.div`
  background-image: ${({
  url
}) => `url(${url})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  flex-shrink: 0;
  height: ${({
  size
}) => size === 'small' ? '30px' : '50px'};
  margin-left: 8px;
  width: ${({
  size
}) => size === 'small' ? '30px' : '50px'};
`;
const StyledButton = styled(_Button)`
  max-height: ${({
  size
}) => size === 'small' ? '38px' : '54px'};
  height: ${({
  size
}) => size === 'small' ? '38px' : '54px'};

  && {
    border-left: 1px solid #c7cedc;
    background-color: #f6f7fb;
    text-transform: initial;
    padding: 0 24px;
    font-size: 1rem;
    border-radius: 0 4px 4px 0;
  }
`;